if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.points = new Map();
        this.resetZoom();

        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;

          const image = this.querySelector(
            '.product-media-modal__content > img.active'
          );

          if (!image || event.target !== image) return;

          event.preventDefault();

          if (this.points.size === 0) {
            this.wasPinch = false;
            this.dragged = false;
            this.downTime = Date.now();
            this.downX = event.clientX;
            this.downY = event.clientY;
          }

          this.points.set(event.pointerId, {
            x: event.clientX,
            y: event.clientY
          });

          image.setPointerCapture(event.pointerId);
          this.startGesture();
        });

        this.addEventListener('pointermove', (event) => {
          if (!this.points.has(event.pointerId)) return;

          event.preventDefault();

          this.points.set(event.pointerId, {
            x: event.clientX,
            y: event.clientY
          });

          const points = [...this.points.values()];

          if (points.length >= 2) {
            this.wasPinch = true;

            const distance = this.distance(points);

            this.scale = Math.max(
              1,
              Math.min(
                4,
                this.baseScale * distance / this.baseDistance
              )
            );
          } else {
            const point = points[0];

            if (
              Math.hypot(
                point.x - this.downX,
                point.y - this.downY
              ) > 12
            ) {
              this.dragged = true;
            }

            if (this.scale > 1) {
              this.x = this.baseX + point.x - this.anchorX;
              this.y = this.baseY + point.y - this.anchorY;
            }
          }

          this.paintZoom();
        });

        this.addEventListener('pointerup', (event) => {
          if (!this.points.has(event.pointerId)) return;

          event.preventDefault();

          const moved = Math.hypot(
            event.clientX - this.downX,
            event.clientY - this.downY
          );

          this.points.delete(event.pointerId);

          if (this.points.size > 0) {
            this.startGesture();
            return;
          }

          const isTap =
            !this.wasPinch &&
            !this.dragged &&
            moved <= 12 &&
            Date.now() - this.downTime < 700;

          if (!isTap) return;

          if (this.scale > 1.01) {
            this.resetZoom();
          } else {
            this.hide();
          }
        });

        this.addEventListener('pointercancel', (event) => {
          this.points.delete(event.pointerId);
          this.wasPinch = true;
          this.dragged = true;

          if (this.points.size) this.startGesture();
        });

        // Prevent Safari's separate native gesture zoom
        // while interacting with the popup image.
        ['gesturestart', 'gesturechange', 'gestureend'].forEach(
          (type) => {
            this.addEventListener(
              type,
              (event) => {
                if (this.points.size || this.wasPinch) {
                  event.preventDefault();
                }
              },
              { passive: false }
            );
          }
        );
      }

      distance(points) {
        return Math.max(
          1,
          Math.hypot(
            points[0].x - points[1].x,
            points[0].y - points[1].y
          )
        );
      }

      startGesture() {
        const points = [...this.points.values()];

        this.baseScale = this.scale;
        this.baseX = this.x;
        this.baseY = this.y;

        if (points.length >= 2) {
          this.wasPinch = true;
          this.baseDistance = this.distance(points);
        } else if (points.length === 1) {
          this.anchorX = points[0].x;
          this.anchorY = points[0].y;
        }
      }

      resetZoom() {
        this.scale = 1;
        this.x = 0;
        this.y = 0;

        this.querySelectorAll('img').forEach((image) => {
          image.style.transform = '';
        });
      }

      paintZoom() {
        const image = this.querySelector(
          '.product-media-modal__content > img.active'
        );

        if (!image) return;

        const limitX =
          image.clientWidth * (this.scale - 1) / 2;
        const limitY =
          image.clientHeight * (this.scale - 1) / 2;

        this.x = Math.max(-limitX, Math.min(limitX, this.x));
        this.y = Math.max(-limitY, Math.min(limitY, this.y));

        image.style.transform =
          `translate(${this.x}px, ${this.y}px) ` +
          `scale(${this.scale})`;
      }

      hide() {
        super.hide();
        this.points.clear();
        this.wasPinch = false;
        this.resetZoom();
      }

      show(opener) {
        this.points.clear();
        this.wasPinch = false;
        this.resetZoom();
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId =
          this.openedBy.getAttribute('data-media-id');

        this.querySelectorAll('[data-media-id]').forEach(
          (element) => {
            element.classList.toggle(
              'active',
              element.getAttribute('data-media-id') === mediaId
            );
          }
        );

        const container = this.querySelector(
          '[role="document"]'
        );

        if (container) {
          container.scrollLeft = 0;
          container.scrollTop = 0;
        }

        const activeMedia = this.querySelector(
          '.product-media-modal__content > .active'
        );

        if (
          activeMedia?.nodeName === 'DEFERRED-MEDIA' &&
          typeof activeMedia.loadContent === 'function'
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}